import React, { useMemo } from 'react';
import { Source, Layer } from 'react-map-gl';
import {
  lassoFill,
  lassoLine,
  LASSO,
} from '../../../../components/property-map-viewer/MapLayersUtil';
import { useFilterStore } from '../../../public-filters/application/filterStore';

type LassoPolygonSourceProps = {};

// Renders polygon onto the map
export const LassoPolygonSource: React.FC<LassoPolygonSourceProps> = () => {
  const { polygonFeatures: polygon } = useFilterStore();

  const lassoGeoJson = useMemo(() => {
    if (!polygon || polygon.length === 0) return null;

    return {
      type: 'FeatureCollection' as const,
      features: polygon,
    };
  }, [polygon]);

  if (!lassoGeoJson) {
    return null;
  }

  return (
    <Source id={LASSO} type="geojson" data={lassoGeoJson}>
      <Layer {...lassoFill} />
      <Layer {...lassoLine} />
    </Source>
  );
};
